// extracted by mini-css-extract-plugin
export var active = "pagination-module--active--5LkfV";
export var arrow = "pagination-module--arrow--BMjGk";
export var container = "pagination-module--container--RX3m2";
export var disabled = "pagination-module--disabled--yE+Pz";
export var pageLink = "pagination-module--page-link--CXbWR";